import * as React from "react";
const SvgDangerFlag = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 4H4V16H6V12H16L14 8L16 4H6Z", fill: "#D33637" }));
export default SvgDangerFlag;
